<template>
    <div class="tp-tpl">
        <div class="h-panel-bar">
            <span class="h-panel-title">{{(definition.name || '') + '凭证模板'}}</span>
            <span class="bar-tools">
                <Button size="s" @click="addTpl">新建模板</Button>
                <Button size="s" color="red" :disabled="!form.id" @click="removeTpl">删除</Button>
            </span>
        </div>
        <div class="tp-tpl-body">
            <div class="tp-tpl-side">
                <div v-for="t in tpls" :key="t.id" class="tp-tpl-item" :class="{selected: form.id === t.id}" @click="selectTpl(t)">
                    {{t.name || '未命名模板'}}
                </div>
                <div v-if="!tpls.length" class="text-center dark2-color" style="padding:16px 0">暂无模板</div>
            </div>

            <div class="tp-tpl-main" v-if="form.id || isNew">
                <Form :label-width="90" mode="block">
                    <FormItem label="模板名称" required>
                        <Input v-model="form.name" placeholder="请输入模板名称" style="width:220px"/>
                    </FormItem>
                    <FormItem label="凭证字" required>
                        <Select v-model="form.voucherWordId" :datas="wordOptions" keyName="id" titleName="word" style="width:220px"/>
                    </FormItem>
                    <FormItem label="凭证日期" required>
                        <Select v-model="form.dateField" :datas="dateColumns" placeholder="请选择日期列" style="width:220px"/>
                    </FormItem>
                    <FormItem label="凭证摘要">
                        <Select v-model="form.summaryField" :datas="allColumns" placeholder="请选择摘要列" style="width:220px"/>
                    </FormItem>
                </Form>

                <div class="tp-sub-title">
                    <span>匹配规则</span>
                    <Button size="xs" @click="addRule">新增一行</Button>
                </div>
                <table class="grid">
                    <thead>
                    <tr>
                        <th style="width:200px">匹配列</th>
                        <th style="width:120px">逻辑关系</th>
                        <th>匹配值</th>
                        <th style="width:80px">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(r, i) in form.rules" :key="i">
                        <td><Select v-model="r.fieldName" :datas="allColumns" placeholder="请选择匹配列"/></td>
                        <td>
                            <Select v-model="r.logic" :datas="[{title:'并且',key:'AND'},{title:'或者',key:'OR'}]" :deletable="false"/>
                        </td>
                        <td><Input v-model="r.matchValue" placeholder="请输入匹配值，多个值用逗号分隔"/></td>
                        <td class="actions"><span @click="removeRule(i)">删除</span></td>
                    </tr>
                    <tr v-if="!form.rules.length">
                        <td colspan="4" class="text-center" style="padding:12px">无（匹配全部记录）</td>
                    </tr>
                    </tbody>
                </table>

                <div class="tp-sub-title">
                    <span>凭证明细</span>
                    <Button size="xs" @click="addItem">新增一行</Button>
                </div>
                <table class="grid">
                    <thead>
                    <tr>
                        <th style="width:110px">行类型</th>
                        <th style="width:220px">科目</th>
                        <th style="width:130px">金额列</th>
                        <th style="width:110px">取值比例(%)</th>
                        <th style="width:110px">方向</th>
                        <th style="width:120px">数量列</th>
                        <th style="width:120px">单位列</th>
                        <th style="width:140px">辅助核算</th>
                        <th style="width:110px">操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, i) in form.items" :key="i">
                        <td>
                            <Select v-model="it.rowType" :datas="rowTypes" :deletable="false"/>
                        </td>
                        <td>
                            <Select v-model="it.subjectId" :datas="subjectOptions" keyName="id" titleName="fullName"
                                    :filterable="true" placeholder="请选择科目" @change="onSubjectChange(it)"/>
                        </td>
                        <td>
                            <Select v-model="it.amountField" :datas="numberColumns" placeholder="请选择金额列"
                                    v-if="it.rowType !== 'BALANCE'"/>
                        </td>
                        <td>
                            <NumberInput v-model="it.amountRate" :min="0" :max="100" v-if="it.rowType !== 'BALANCE'"/>
                        </td>
                        <td>
                            <Select v-model="it.direction" :datas="[{title:'借',key:'D'},{title:'贷',key:'C'}]" :deletable="false"/>
                        </td>
                        <td><Select v-model="it.quantityField" :datas="numberColumns" placeholder="可选"/></td>
                        <td><Select v-model="it.unitField" :datas="allColumns" placeholder="可选"/></td>
                        <td><Select v-model="it.auxiliaryField" :datas="allColumns" placeholder="可选"/></td>
                        <td class="actions">
                            <span @click="copyItem(i)">复制</span>
                            <span @click="removeItem(i)">删除</span>
                        </td>
                    </tr>
                    <tr v-if="!form.items.length">
                        <td colspan="9" class="text-center" style="padding:12px">至少保留两行</td>
                    </tr>
                    </tbody>
                </table>
                <div class="tp-tip">
                    规则：一个数据科目和一个记账科目；必须要有借方和贷方两个方向；只能有一个自动平衡行。
                </div>
            </div>
            <div v-else class="tp-tpl-main text-center dark2-color" style="padding:40px">
                请点击「新建模板」或从左侧选择模板
            </div>
        </div>
        <div class="h-panel-bar text-right">
            <Button @click="$emit('close')">取消</Button>
            <Button color="primary" :disabled="!form.id && !isNew" @click="save">保存</Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TripartiteVoucherTpl",
        props: {
            definition: Object
        },
        data() {
            return {
                tpls: [],
                isNew: false,
                form: {id: null, name: '', voucherWordId: null, dateField: '', summaryField: '', rules: [], items: []},
                rowTypes: [
                    {title: '数据科目', key: 'DATA'},
                    {title: '记账科目', key: 'SUBJECT'},
                    {title: '自动平衡', key: 'BALANCE'}
                ],
                words: [],
                subjects: []
            };
        },
        computed: {
            fields() {
                return (this.definition && this.definition.dataFields) || [];
            },
            allColumns() {
                return this.fields.map(f => ({title: f.displayName, key: f.fieldName}));
            },
            numberColumns() {
                return this.fields.filter(f => f.fieldType === 'NUMBER')
                    .map(f => ({title: f.displayName, key: f.fieldName}));
            },
            dateColumns() {
                let cols = this.fields.filter(f => f.fieldType === 'DATE')
                    .map(f => ({title: f.displayName, key: f.fieldName}));
                return cols.length ? cols : this.allColumns;
            },
            wordOptions() {
                return this.words;
            },
            subjectOptions() {
                return this.subjects.map(s => Object.assign({}, s, {fullName: s.code + ' ' + s.name}));
            }
        },
        methods: {
            loadTpls() {
                this.$api.tripartite.tpl.list(this.definition.id).then(({data}) => {
                    this.tpls = data || [];
                    if (this.tpls.length) {
                        this.selectTpl(this.tpls[0]);
                    } else {
                        this.form = {id: null, name: '', voucherWordId: null, dateField: '', summaryField: '', rules: [], items: []};
                        this.isNew = false;
                    }
                });
            },
            selectTpl(t) {
                this.isNew = false;
                this.form = JSON.parse(JSON.stringify(t));
                this.form.rules = this.form.rules || [];
                this.form.items = this.form.items || [];
            },
            addTpl() {
                this.isNew = true;
                this.form = {
                    id: null,
                    name: '模板' + (this.tpls.length + 1),
                    voucherWordId: this.words.length ? this.words[0].id : null,
                    dateField: this.dateColumns.length ? this.dateColumns[0].key : '',
                    summaryField: '',
                    rules: [],
                    items: [this.newItem('DATA', 'D'), this.newItem('SUBJECT', 'C')]
                };
            },
            newItem(rowType, direction) {
                return {
                    rowType: rowType,
                    subjectId: null,
                    subjectCode: '',
                    subjectName: '',
                    amountField: this.numberColumns.length ? this.numberColumns[0].key : '',
                    amountRate: 100,
                    direction: direction,
                    quantityField: null,
                    unitField: null,
                    auxiliaryField: null
                };
            },
            addItem() {
                this.form.items.push(this.newItem('SUBJECT', 'C'));
            },
            copyItem(i) {
                let copy = JSON.parse(JSON.stringify(this.form.items[i]));
                copy.subjectId = copy.subjectId;
                this.form.items.splice(i + 1, 0, copy);
            },
            removeItem(i) {
                if (this.form.items.length <= 2) {
                    this.$Message('至少保留两行');
                    return;
                }
                this.form.items.splice(i, 1);
            },
            addRule() {
                this.form.rules.push({fieldName: this.allColumns.length ? this.allColumns[0].key : '', logic: 'AND', matchValue: ''});
            },
            removeRule(i) {
                this.form.rules.splice(i, 1);
            },
            onSubjectChange(it) {
                let s = this.subjects.find(x => x.id === it.subjectId);
                if (s) {
                    it.subjectCode = s.code;
                    it.subjectName = s.name;
                }
            },
            validate() {
                let items = this.form.items || [];
                if (items.length < 2) {
                    this.$Message('至少保留两行');
                    return false;
                }
                for (let it of items) {
                    if (!it.subjectId) {
                        this.$Message('请选择科目');
                        return false;
                    }
                    if (it.rowType !== 'BALANCE' && !it.amountField) {
                        this.$Message('请选择金额列');
                        return false;
                    }
                    if (it.amountRate === null || it.amountRate === undefined || it.amountRate <= 0 || it.amountRate > 100) {
                        this.$Message('取值比例范围为大于0小于等于100');
                        return false;
                    }
                }
                let hasData = items.some(x => x.rowType === 'DATA');
                let hasSubject = items.some(x => x.rowType === 'SUBJECT');
                if (!hasData || !hasSubject) {
                    this.$Message('必须要有数据科目和记账科目');
                    return false;
                }
                let dirs = new Set(items.map(x => x.direction));
                if (!dirs.has('D') || !dirs.has('C')) {
                    this.$Message('必须要有借方和贷方两个方向');
                    return false;
                }
                let balance = items.filter(x => x.rowType === 'BALANCE');
                if (balance.length > 1) {
                    this.$Message('只能有一个自动平衡行');
                    return false;
                }
                if (!this.form.dateField) {
                    this.$Message('请选择凭证日期列');
                    return false;
                }
                if (!this.form.voucherWordId) {
                    this.$Message('请选择凭证字');
                    return false;
                }
                return true;
            },
            save() {
                if (!this.validate()) {
                    return;
                }
                let p = JSON.parse(JSON.stringify(this.form));
                this.$api.tripartite.tpl.save(this.definition.id, p).then(() => {
                    this.$Message('保存成功');
                    this.isNew = false;
                    this.loadTpls();
                });
            },
            removeTpl() {
                if (!this.form.id) {
                    return;
                }
                this.$Confirm('删除后将无法恢复，是否继续？').then(() => {
                    this.$api.tripartite.tpl.delete(this.definition.id, this.form.id).then(() => {
                        this.$Message('删除成功');
                        this.isNew = false;
                        this.loadTpls();
                    });
                });
            },
            loadWords() {
                return this.$api.setting.voucherWord.list().then(({data}) => {
                    this.words = data || [];
                });
            },
            loadSubjects() {
                return this.$api.setting.subject.list().then(({data}) => {
                    this.subjects = data || [];
                });
            }
        },
        mounted() {
            Promise.all([this.loadWords(), this.loadSubjects()]).then(() => {
                this.loadTpls();
            });
        }
    };
</script>

<style lang="less" scoped>
    .tp-tpl {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .tp-tpl-body {
        flex: 1;
        display: flex;
        overflow: hidden;
    }

    .tp-tpl-side {
        width: 200px;
        flex: none;
        border-right: 1px solid @gray2-color;
        overflow: auto;

        .tp-tpl-item {
            padding: 8px 12px;
            cursor: pointer;

            &.selected, &:hover {
                background-color: @hover-background-color;
                color: @primary-color;
            }
        }
    }

    .tp-tpl-main {
        flex: 1;
        width: 0;
        overflow: auto;
        padding: 10px 12px;
    }

    .tp-sub-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 12px 0 6px;
        font-weight: bold;
    }

    .actions span {
        color: @primary-color;
        cursor: pointer;
        margin-right: 6px;
    }

    .tp-tip {
        color: @dark2-color;
        font-size: 12px;
        margin-top: 10px;
    }
</style>
